










import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'

interface Data {}

interface Methods {
}

interface Computed {}
interface Props {
  isWhite: boolean,
  isLightPurple: boolean,
  isBordered: boolean
}

export default Vue.extend({
  name: 'UiButton',
  props: {
    isWhite: {
      type: Boolean,
      default: () => false
    },
    isLightPurple: {
      type: Boolean,
      default: () => false
    },
    isBordered: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    computeClass () {
      return [
        this.isWhite ? 'ui-button_white'
          : this.isLightPurple ? 'ui-button_light-purple' : 'ui-button_purple',
        this.isBordered ? 'ui-button_bordered' : ''
      ]
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
